var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"dropdown-item",on:{"click":_vm.handleClick}},[_c('span',{staticClass:"icon-action"},[_c('i',{class:_vm.iconClass}),_vm._v("\n    "+_vm._s(_vm.label)+"\n  ")])])
}
var staticRenderFns = []

export { render, staticRenderFns }